export default {
  /**
   * @param {object} data - Package object that needs to be formatted for CSV.
   * @returns {Array<object>} - Formated data obj for CSV report.
   */
  formatPackages(data) {
    // Don't destructure because 'package' is a reserved word.
    return data.map((item) => ({
      package: item.package.name,
      installed: item.package.installed,
      version: item.package.version,
      publisher: item.package.publisher,
      description: item.package.description,
      vulnerabilities: item.vulnerability.join(', '),
    }));
  },

  /**
   * @param {object} data - Traffic object that needs to be formatted for CSV.
   * @returns {Array<object>} - Formatted data object for csv CSV report.
   */
  formatTraffic(data) {
    return data.map((item) => ({
      ip: item.ip,
      url: item.domain,
      domain: item.organization === '' ? '' : item.organization,
      app: item.application,
      direction: item.direction,
      connections: item.count,
      behavior: item.behavior.join(', '),
      threatFeeds: item.threatFeeds.join(', '),
    }));
  },
};
